import { useEffect, useMemo, useState } from "react";
import { useIntl } from "react-intl";
import { useFetchProducts } from "~/api/salesForce/useFetchProducts";
import { ConfigurationAccordions } from "~/components/atoms/Accordion/Accordions.type";
import ConfigurationAccordion from "~/components/molecules/ConfigurationAccordion/ConfigurationAccordion";
import useHairProducts from "~/hooks/useHairProducts";
import { ProductRadioGroupOption } from "~/stores/checkout/product";

type EyebrowGraftsProps = {
  collapsible?: boolean;
  openedAccordion?: ConfigurationAccordions;
  isEditable?: boolean;
};

const EyebrowGrafts = ({
  openedAccordion,
  collapsible,
  isEditable = true,
}: EyebrowGraftsProps) => {
  const intl = useIntl();
  const { data: allProducts } = useFetchProducts();
  const { eyebrowProduct, setEyebrowProduct } = useHairProducts();

  const products: ProductRadioGroupOption[] = useMemo(
    () =>
      allProducts.hair.eyebrow.transplantation?.map((option) => ({
        ...option,
        name: option.name,
        text: intl.formatMessage(
          { id: "configuration.grafts.value" },
          { from: option.grafts.from, to: option.grafts.to }
        ),
      })) ?? [],
    [allProducts.hair.beard.transplantation]
  );

  const [selectedOption, setSelectedOption] = useState<
    ProductRadioGroupOption | undefined
  >(
    products.find((product) => product.id === eyebrowProduct?.id) || products[0]
  );

  useEffect(() => {
    if (!selectedOption) {
      setSelectedOption(
        products.find((product) => product.id === eyebrowProduct?.id) ||
          products[0]
      );
    }
  }, [products, eyebrowProduct]);

  const isOpen = useMemo(
    () => openedAccordion == ConfigurationAccordions.EYEBROW_GRAFTS,
    [openedAccordion]
  );

  if (!selectedOption) return null;

  return (
    <ConfigurationAccordion
      itemValue={ConfigurationAccordions.EYEBROW_GRAFTS}
      collapsible={collapsible}
      isOpen={isOpen}
      products={products}
      setSelectedOption={setSelectedOption}
      title={intl.formatMessage({
        id: "configuration.eyebrows.grafts.title",
      })}
      closedAccordionDescription={intl.formatMessage(
        { id: "configuration.grafts.value" },
        {
          from: selectedOption.grafts.from,
          to: selectedOption.grafts.to,
        }
      )}
      product={eyebrowProduct}
      setProduct={setEyebrowProduct}
      isEditable={isEditable}
    />
  );
};

export default EyebrowGrafts;
